const ASSET_BASE = process.env.PUBLIC_URL || "";

/** Gradient B mark from /public/B-Logo.svg */
export function BlonixMark({ className = "h-7 w-auto", alt = "" }) {
  return (
    <img
      src={`${ASSET_BASE}/B-Logo.svg`}
      alt={alt}
      className={className}
      draggable={false}
    />
  );
}

/** Full Blonix wordmark from /public/Blonix-Logo.svg */
export function BlonixWordmark({ className = "h-[22px] w-auto", alt = "Blonix" }) {
  return (
    <img
      src={`${ASSET_BASE}/Blonix-Logo.svg`}
      alt={alt}
      className={className}
      draggable={false}
    />
  );
}
